import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Sep 12 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { GenericTransportLayer } from '../GenericTransportLayer';
import { DataUploadConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import { Inject } from '@logio/typescript-ioc';
import api from '../../../shared/api';
import { action } from 'mobx';
export var DataUploadLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(DataUploadLayer, _GenericTransportLaye);

  function DataUploadLayer() {
    _classCallCheck(this, DataUploadLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataUploadLayer).call(this, CONSTANTS.API.ENDPOINTS.DATA_UPLOAD));
  }

  _createClass(DataUploadLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "upload",
    value: function upload(data, onUploadProgress) {
      var uploadPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_UPLOAD).concat(CONSTANTS.API.ENDPOINTS.COMPETITORS_DATA)).setHeaders({
        'Content-type': 'multipart/form-data'
      }).post(data, {
        responseType: 'json',
        onUploadProgress: onUploadProgress
      }).then(function (response) {
        console.log(response);
        return response.data;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return uploadPromise;
    }
  }, {
    key: "uploadSensitivity",
    value: function uploadSensitivity(data, onUploadProgress) {
      var uploadPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_UPLOAD_SENSITIVITY)).setHeaders({
        'Content-type': 'multipart/form-data'
      }).post(data, {
        responseType: 'json',
        onUploadProgress: onUploadProgress
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return uploadPromise;
    }
  }, {
    key: "uploadFamily",
    value: function uploadFamily(data, onUploadProgress) {
      var uploadPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_UPLOAD_FAMILY)).setHeaders({
        'Content-type': 'multipart/form-data'
      }).post(data, {
        responseType: 'json',
        onUploadProgress: onUploadProgress
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return uploadPromise;
    }
  }, {
    key: "approve",
    value: function approve(id) {
      var approvePromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_UPLOAD).concat(CONSTANTS.API.ENDPOINTS.COMPETITORS_DATA).concat(CONSTANTS.API.ENDPOINTS.APPROVE, "/").concat(id)).put({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return approvePromise;
    }
  }, {
    key: "reject",
    value: function reject(id) {
      var rejectPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_UPLOAD).concat(CONSTANTS.API.ENDPOINTS.COMPETITORS_DATA).concat(CONSTANTS.API.ENDPOINTS.REJECT, "/").concat(id)).put({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return rejectPromise;
    }
  }]);

  return DataUploadLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", DataUploadConverter)], DataUploadLayer.prototype, "converter", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [FormData, Object]), __metadata("design:returntype", Promise)], DataUploadLayer.prototype, "upload", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [FormData, Object]), __metadata("design:returntype", Promise)], DataUploadLayer.prototype, "uploadSensitivity", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [FormData, Object]), __metadata("design:returntype", Promise)], DataUploadLayer.prototype, "uploadFamily", null);